// Shopify's /search can't reliably mix result types in one query, so the main
// results page (products by default) fetches articles and pages separately via
// the Section Rendering API and appends them below as their own groups.
class SearchExtraResults extends HTMLElement {
  connectedCallback() {
    // Respect an explicit type filter (e.g. /search?type=article)
    if (new URLSearchParams(window.location.search).has('type')) return;

    this.searchUrl = this.dataset.searchUrl;
    this.terms = this.dataset.terms;
    this.sectionId = this.dataset.sectionId;
    this.knownLinks = new Set(
      [...document.querySelectorAll('#product-grid .full-unstyled-link')].map((link) => link.getAttribute('href'))
    );

    this.dataset.types.split(',').forEach((type) => this.loadType(type.trim()));
  }

  buildUrl(type) {
    const params = new URLSearchParams({ q: this.terms, type });
    params.set('options[prefix]', 'last');
    return `${this.searchUrl}?${params}`;
  }

  async loadType(type) {
    try {
      const response = await fetch(`${this.buildUrl(type)}&section_id=${this.sectionId}`);
      if (!response.ok) return;

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const grid = doc.querySelector('#product-grid ul.grid');
      if (!grid) return;

      const items = [...grid.children].filter((item) => {
        const href = item.querySelector('.full-unstyled-link')?.getAttribute('href');
        return !href || !this.knownLinks.has(href);
      });
      if (!items.length) return;

      this.appendChild(this.buildGroup(type, grid.className, items));
    } catch (error) {
      console.error(`Could not load ${type} search results`, error);
    }
  }

  buildGroup(type, gridClassName, items) {
    const group = document.createElement('section');
    group.className = 'search-extra-results__group';

    const header = document.createElement('div');
    header.className = 'search-extra-results__header';

    const heading = document.createElement('h2');
    heading.className = 'search-extra-results__heading h3';
    heading.textContent = this.dataset[`heading${type[0].toUpperCase()}${type.slice(1)}`] || type;

    const viewAll = document.createElement('a');
    viewAll.className = 'link underlined-link';
    viewAll.href = this.buildUrl(type);
    viewAll.textContent = this.dataset.viewAllLabel;

    header.append(heading, viewAll);

    const list = document.createElement('ul');
    list.className = gridClassName;
    list.setAttribute('role', 'list');
    items.forEach((item) => {
      // Scroll-reveal only runs on initial page load, so injected items must not start hidden
      item.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');
      item.removeAttribute('data-cascade');
      list.appendChild(item);
    });

    group.append(header, list);
    return group;
  }
}

customElements.define('search-extra-results', SearchExtraResults);
